import { Reveal, SectionHeader } from "./shared";
import { experience } from "../../data/portfolioData";

export const ExperienceTimeline = () => (
  <section id="experience" className="py-20 lg:py-28 bg-[#090C13]" data-testid="experience-timeline-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeader
        index="04"
        eyebrow="Journey & Experience"
        title="My Experience"
        description="Not a resume — a journey of shipping real systems, for real users, in production."
        testId="experience-header"
      />

      <div className="relative max-w-3xl">
        <div className="absolute left-[7px] top-2 bottom-2 w-px bg-gradient-to-b from-amber-400/60 via-white/10 to-transparent" />

        {experience.map((e, i) => (
          <Reveal key={i} delay={i * 0.12} className="relative pl-10 pb-12 last:pb-0">
            <span className="absolute left-0 top-2 h-[15px] w-[15px] rounded-full border-2 border-amber-400 bg-[#090C13] shadow-[0_0_14px_rgba(245,158,11,0.5)]" />
            <article
              className="rounded-2xl border border-white/[0.07] bg-[#0F1420] p-6 sm:p-8 transition-all duration-500 hover:border-white/[0.14]"
              data-testid={`experience-item-${i}`}
            >
              <div className="flex flex-wrap items-baseline justify-between gap-2">
                <h3 className="font-display text-xl sm:text-2xl font-semibold tracking-tight text-slate-50">{e.role}</h3>
                <span className="font-code text-xs text-amber-400/90">{e.duration}</span>
              </div>
              <p className="mt-1 text-sm font-medium text-slate-400">{e.company}</p>
              <p className="mt-4 text-sm text-slate-400 leading-relaxed">{e.description}</p>

              <ul className="mt-5 space-y-2.5">
                {e.responsibilities.map((r) => (
                  <li key={r} className="flex gap-2.5 text-sm text-slate-300">
                    <span className="mt-[7px] h-1 w-1 shrink-0 rounded-full bg-amber-400" />
                    {r}
                  </li>
                ))}
              </ul>

              {e.achievements?.length > 0 && (
                <div className="mt-5 rounded-xl border border-emerald-400/15 bg-emerald-400/[0.04] px-4 py-3">
                  {e.achievements.map((a) => (
                    <p key={a} className="text-xs text-emerald-300/90 flex gap-2 py-0.5">
                      <span>→</span> {a}
                    </p>
                  ))}
                </div>
              )}

              <div className="mt-5 flex flex-wrap gap-2">
                {e.technologies.map((t) => (
                  <span key={t} className="rounded-md border border-white/[0.08] bg-white/[0.03] px-2.5 py-1 text-[11px] text-slate-400">
                    {t}
                  </span>
                ))}
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
